import { useContext, useEffect } from 'react'
import { useAnalyticsTrack } from '@/features/amplitude'
import { UpgradeFromManualStatementsDialog } from './UpgradeStatementsDialog'
import { UpgradeFromLBADialog } from './UpgradeBaDialog'
import { PlaidPostAuthDialogType, PlaidLinkContext } from './LinkContext'

export const PostPlaidAuthDialog = () => {
  const { postAuthDialog, setPostAuthDialog } = useContext(PlaidLinkContext)
  const track = useAnalyticsTrack()

  useEffect(() => {
    if (postAuthDialog?.type) {
      track('viewed post plaid auth modal', { ...postAuthDialog })
    }
  }, [track, postAuthDialog])

  const handleCloseDialog = () => {
    setPostAuthDialog(null)
  }

  if (!postAuthDialog) return null

  return (
    <>
      <UpgradeFromManualStatementsDialog
        postAuthDialog={postAuthDialog}
        isOpen={
          postAuthDialog?.type ===
          PlaidPostAuthDialogType.UPGRADE_FROM_MANUAL_STATEMENTS
        }
        onClose={handleCloseDialog}
      />

      <UpgradeFromLBADialog
        postAuthDialog={postAuthDialog}
        isOpen={
          postAuthDialog?.type === PlaidPostAuthDialogType.UPGRADE_FROM_LBA
        }
        onClose={handleCloseDialog}
      />
    </>
  )
}
